import API_BASE_URL from '../config/config';

// Strip any trailing slash from the configured base URL
export const apiBaseUrl = API_BASE_URL.replace(/\/+$/, '');

/**
 * Builds a full API URL by prepending apiBaseUrl.
 * Usage: this.$api('/login/login.php')
 *   → 'http://localhost/striglia/login/login.php'   (when apiBaseUrl is set)
 *   → '/login/login.php'                            (when apiBaseUrl is empty)
 */
export const buildApiUrl = (path) => {
  const p = path.startsWith('/') ? path : '/' + path;
  return apiBaseUrl ? apiBaseUrl + p : p;
};
